"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.navBarBoxShadow = exports.hoverEase = exports.cornerRadiusRound = exports.blockBoxShadow = exports.Z_INDEX = exports.BOX_SHADOW = void 0;
var _colors = _interopRequireDefault(require("../styles/colors"));
var _color = require("../utils/color.utils");
var _styledComponents = require("styled-components");
var navBarBoxShadow = exports.navBarBoxShadow = '0 0 6px 0 rgba(0, 18, 71, 0.08)';
var blockBoxShadow = exports.blockBoxShadow = '0 2px 8px 0 rgba(0, 0, 0, 0.08), 0 0 0 1px rgba(0, 0, 0, 0.05);';
var hoverEase = exports.hoverEase = ['0.15s', 'ease'];
var Z_INDEX = exports.Z_INDEX = {
  MODAL: 10,
  TOP: 900,
  TOP_MOST: 1000,
  NAVBAR: 2000,
  FULL_SCREEN: 3000,
  LOADER: 10000,
  POPOVER: 20000,
  MENU: 30000,
  TOAST: 1000001,
  SPLASH: 2147483647
};
var BOX_SHADOW = exports.BOX_SHADOW = {
  checkbox: {
    checked: (0, _styledComponents.css)(["box-shadow:0px 2px 5px 0px ", ";"], _colors["default"].blue50_20),
    "default": (0, _styledComponents.css)(["box-shadow:inset 0px 1px 2px ", ";"], (0, _color.opacityHex)(_colors["default"].neutral900, 15))
  }
};
var cornerRadiusRound = exports.cornerRadiusRound = '999px';
//# sourceMappingURL=variables.js.map